import get from "lodash/get";
import React from "react";

export class SelectionCell extends React.Component {
    _stopPropagation (e) {
      e.stopPropagation();
    }

    _handleChange = e => {
      const { rowData, rowIndex, column } = this.props
      const { onChange } = column
  
      onChange({ checked: e.target.checked, rowData, rowIndex, event: e })
    }
  
    render() {
      const { rowData, column } = this.props
      const { selectedRowKeys, rowKey, i18n } = column

      const checked = !!selectedRowKeys[rowData[rowKey]];
  
      return (
        <label onClick={ this._stopPropagation } onDoubleClick={ this._stopPropagation }>
          <input type="checkbox" checked={checked} title={ get(i18n, checked  ? "unselectRow" : "selectRow" ) } onChange={this._handleChange} />
        </label>
      )
    }
}

export class SelectionHeader extends React.PureComponent {
  ref = React.createRef();

  _handleClick (e) {
    e.stopPropagation();
  }

  _handleChange = e => {
    const { column } = this.props
    const { onSelectAll } = column
    onSelectAll({ checked: e.target.checked })
  }

  componentDidMount() {
    this.updateIntermittentState()
  }

  componentDidUpdate() {
    this.updateIntermittentState()
  }

  updateIntermittentState() {
    if (!this.ref.current) return;    
    this.ref.current.indeterminate = this.props.column.indeterminate;
  }

  render() {
    const { column: { i18n, allSelected } } = this.props

    return (
      <label onClick={ this._handleClick }>
        <input ref={ this.ref } checked={ allSelected } type="checkbox" title={ get(i18n, allSelected  ? "unselectAll" : "selectAll" ) } onChange={this._handleChange} />
      </label>
    )
  }
}